module.exports = __webpack_public_path__ + "static/media/logo-comethswap.36ba55c0.png";